module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1 unnumbered",
    attrs: {
      "id": "its-all-an-act"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "00em",
      "padding-top": "70px"
    }
  }, [_c('em', [_vm._v("It’s All an Act: Practising the Art of Successful Classroom Management")]), _vm._v(" is packed full of practical advice and tips to help teachers to successfully master the art of classroom management. From setting up your classroom, to advice on starting with new classes and what to do when every lesson with a class feels like a nightmare, Jim Wood’s realistic approach to classroom management will help you to be in control from day one. As a young trainee teacher sat in a lecture theatre at Southampton University, I recall watching him demonstrate many of the techniques and practices, which he has distilled into this book. I know his strategies work and much of my own success in the classroom to-date is down to implementing these within my practice. Having had the pleasure of working with him during my early years in teaching and through my subsequent work with coordinating training for teachers at every stage of their career, I have seen the benefits of his honest, supportive, and non-judgemental approach. To this day I never underestimate the power of the slow walk in many aspects of life, and whether you are just at the start of your teaching journey, or if you are a more experienced practitioner, this is the book for you!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("David Higginbottom,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Deputy Director,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("HISP Teaching School Hubs.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdde7154","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 66
// module chunks = 0